// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAppAvailabilityGetBody = {
  clientPlatform?: "ios" | "android";
  clientVersion?: string;
};

export type typeAppAvailabilityGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    iosStoreUrl?: string;
    androidStoreUrl?: string;
    updateRequirement?: "none" | "optional" | "required";
    latestVersion?: string;
  };
};

export type typeAppAvailabilityGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAppAvailabilityGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAppAvailabilityGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAppAvailabilityGetBody = {
  type: "object",
  properties: {
    clientPlatform: { type: "string", enum: ["ios", "android"] },
    clientVersion: { type: "string", maxLength: 3000, minLength: 1 },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAppAvailabilityGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAppAvailabilityGetBody);
  }

  return async function postAppAvailabilityGet(
    payload: typeAppAvailabilityGetBody,
  ): Promise<
    typeAppAvailabilityGetOutput200 | typeAppAvailabilityGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAppAvailabilityGet" failed before calling the network. #51279ad5d5c7`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#51279ad5d5c7" },
        },
        data: null,
      } as typeAppAvailabilityGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/app-availability/get`,
      httpMethod: "POST",
      options,
    })) as typeAppAvailabilityGetOutput200 | typeAppAvailabilityGetOutput400;
  };
}
